import VGPopUp from 'components/Controls/VGPopUp';
import React, { Fragment } from 'react';
import { createPortal, unmountComponentAtNode } from 'react-dom';


const SuccessPopup = (props) => {

    const handlepopupClose = () => {
        unmountComponentAtNode(document.getElementById("component-context-migration"));
    }

    const GoToWebsite = () => {
        let a = document.createElement("a");
        a.target = "_blank";
        a.href = 'https://' + props.BuildInDomain + "/" + props.VagaroURL;
        a.click();
        handlepopupClose();
    }

    const PopupBody = () => {
        return (
            <Fragment>
                <div className="myswitch_popup  swich-box-success">
                    <div className="myswitch_popup_box">
                        <div class="myswitch_popup_close" onClick={() => handlepopupClose()}></div>
                        <div className="popup_img">
                            <img src={"https://1a96a36bae7c8550901a-274b8a70320bb26e7a1e0ea7836ee429.ssl.cf2.rackcdn.com/Images/website-published-img.png"} style={{ width: "100%" }}></img>
                        </div>
                        <div className="popup_content">
                            <h3>Congratulations Your Website is Published!</h3>
                            <p>Your website has been successfully transferred to MySite, and is now published and live!</p>
                            <a style={{ cursor: "pointer", color: "#2A90D6" }} onClick={() => GoToWebsite()}><span>https://{props.BuildInDomain}/{props.VagaroURL}</span></a>
                            <div className="actions-btns" style={{ marginTop: "10px" }}>
                                <button className="w-button w-button-primary close-on-click" onClick={() => GoToWebsite()}>Launch Website</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }

    return createPortal(
        <VGPopUp
            show={true}
            onHide={handlepopupClose}
            body={PopupBody()}
            id={"wbswitchpopup"}
        />,
        document.getElementById("component-context-migration")
    )
}

export default SuccessPopup;
